<div class="login-page">

  <div class="login-wrapper">

    <div class="top-logo">

  <a routerLink="/">

    <img
      src="/images/logo_transp.png"
      alt="SmsMurilo"
      class="top-logo-image"
    />

  </a>

    </div>

    <div class="login-card">

      <div class="login-header">

        <h1>Manager</h1>

        <p>
          Acesse sua conta para continuar
        </p>

      </div>

      <form
        [formGroup]="form"
        (ngSubmit)="login()"
        class="login-form"
      >

        <div class="input-group">

          <label>Email</label>

          <input
            type="email"
            formControlName="email"
            placeholder="Digite seu email"
          />

        </div>

        <div class="input-group">

          <label>Senha</label>

          <div class="password-wrapper">

            <input
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Digite sua senha"
            />

            <button
              type="button"
              class="show-password"
              (click)="togglePassword()"
            >

              {{ showPassword ? 'Ocultar' : 'Mostrar' }}

            </button>

          </div>

        </div>

        <div class="forgot-password">

          <a routerLink="/esqueci-senha">

            Esqueci minha senha

          </a>

        </div>

        <div class="captcha-container">

          <re-captcha
            siteKey="6Lf0jvUsAAAAAEEw6fo3BE7xN3XOVYXh0s2pK9SH"
            (resolved)="onCaptchaResolved($event)"
          >
          </re-captcha>

        </div>

        <button
          type="submit"
          [disabled]="loading || !captchaToken"
        >

          <span *ngIf="!loading">
            Entrar
          </span>

          <span *ngIf="loading">
            Entrando...
          </span>

        </button>

        <div
          *ngIf="errorMessage"
          class="error-message"
        >

          {{ errorMessage }}

        </div>

      </form>

    </div>

    <div class="copyright">

      © 2026 SmsMurilo Softwares Inteligentes.
      Todos os direitos reservados.

    </div>

  </div>

</div>